import { render, staticRenderFns } from "./change-warranty-status.vue?vue&type=template&id=65e77b6e&"
import script from "./js/change-warranty-status.js?vue&type=script&lang=js&"
export * from "./js/change-warranty-status.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports